import React from "react";
import { Box, Collapse } from "@mui/material";
import { ExecutionStep } from "./ExecutionStepFormShared";
import ExecutionStepErrorBox from "./ExecutionStepErrorBox";
import SkippedStepOverlay from "./SkippedStepOverlay";

type ExecutionStepEditorPanelProps = {
  step: ExecutionStep;
  isOpen: boolean;
  isJobPendingApproval: boolean;
};

const ExecutionStepEditorPanel = ({
  step,
  isOpen,
  isJobPendingApproval,
}: ExecutionStepEditorPanelProps) => {
  const isSkipped = step.status === "skipped";
  const overlayMessage = !isJobPendingApproval
    ? "Dieser Schritt kann nicht bearbeitet werden, weil der Job nicht mehr ausgeführt werden kann."
    : isSkipped
    ? "Dieser Schritt ist als übersprungen markiert und kann nicht bearbeitet werden."
    : null;

  return (
    <Collapse in={isOpen} timeout={"auto"} unmountOnExit>
      <Box sx={{ position: "relative" }}>
        <ExecutionStepErrorBox error={step.error} />
        {overlayMessage && <SkippedStepOverlay message={overlayMessage} />}
      </Box>
    </Collapse>
  );
};

export default ExecutionStepEditorPanel;
